// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1INSI","topBottomGutter":"Layout_topBottomGutter__W-cvz"};